import { Tooltip } from 'antd'
import cx from 'classnames'

import SharedStyles from '../../SecuritySettings.module.scss'
import Styles from './SamlTextSetting.module.scss'
import { ReactComponent as InfoIcon } from 'assets/icons/info16.svg'

interface Props {
  value: string
  origValue: string
  label: string
  id: string
  hint?: string
  type?: string
  errors: Array<String>
  onChange: (e: any) => void
  onBlur: () => void
  className?: string
  isDisabled?: boolean
  isHidden?: boolean
}

export const SamlTextSetting = ({
  value,
  origValue,
  label,
  id,
  hint,
  type,
  errors,
  onChange,
  onBlur,
  className,
  isDisabled,
  isHidden,
}: Props) => {
  const isTextarea = type === 'textarea'

  return (
    <div
      className={cx(SharedStyles.settingsOption, className, {
        [SharedStyles.disabled]: isDisabled,
        [Styles.hidden]: isHidden,
      })}
    >
      <div className={SharedStyles.inputRow}>
        {label && (
          <label className={SharedStyles.optionHeader} htmlFor={id}>
            {label}
            {hint && (
              <Tooltip title={hint} placement="top" trigger="hover" overlayClassName={SharedStyles.antdOverride}>
                <InfoIcon className={SharedStyles.infoIcon} />
              </Tooltip>
            )}
          </label>
        )}
        {isTextarea && (
          <textarea
            disabled={isDisabled}
            id={id}
            onBlur={() => origValue !== value && onBlur()}
            className={SharedStyles.samlScimInput}
            onChange={onChange}
            rows={6}
            value={value}
          />
        )}
        {!isTextarea && (
          <input
            disabled={isDisabled}
            id={id}
            value={value}
            onBlur={() => origValue !== value && onBlur()}
            className={SharedStyles.samlScimInput}
            onChange={onChange}
            type={type || 'text'}
          />
        )}
        {errors.map((error, idx) => (
          <div key={`samlInputError-${idx}`} className={Styles.samlInputError}>
            {error}
          </div>
        ))}
      </div>
    </div>
  )
}
